import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const overview = {
  monthly_active_users: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/overview/monthly_active_users",
      params,
    ),
  monthly_active_users_by_date: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/overview/monthly_active_users_by_date",
      params,
    ),
  monthly_active_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/overview/monthly_active_members",
      params,
    ),
  monthly_new_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/overview/monthly_new_members",
      params,
    ),
  daily_active_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/overview/daily_active_members",
      params,
    ),
  inactive_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/overview/inactive_members", params),
  invitation_pending: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices(
      "analytics/overview/invitation_pending",
      params,
    ),
  popular_spaces: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/overview/popular_spaces", params),
  popular_posts: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/overview/popular_posts", params),
  top_members: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/overview/top_members", params),
  post_starters: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/overview/post_starters", params),
  activity_score: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/overview/activity_score", params),
};
